export default "1,Sperregjerde\n2,Midlertidig sperregjerde\n3,Beitehage\n4,Fangarm\n5,Bro\n6,Trase for motorisert ferdsel\n7,Båttransport for rein\n"